import { z } from 'zod';

export const supportTicketSchema = z.object({
  subject: z
    .string()
    .min(1, 'Subject is required')
    .max(200, 'Keep the subject under 200 characters.'),
  message: z
    .string()
    .min(1, 'Please describe your issue.')
    .max(5000, 'Keep the message under 5000 characters.'),
});

export type SupportTicketForm = z.infer<typeof supportTicketSchema>;
